import React, { FunctionComponent } from "react";
import variables from "@episerver/design-tokens/dist/json/variables";

import "./shape-variables.scss";

interface Shape {
    name: string;
    radius: string;
}

const shapes = variables.filter(v => v.name?.startsWith("shape"));

export const ShapeVariables: FunctionComponent = () => (
    <>
        {shapes.map((s: Shape) => (
            <span
                className="epi-ds-site-shape-variables"
                style={{ borderRadius: s.radius }}
                key={s.name}
            >
                {/* Borrow the "language-text" class from Gatsby's default <code> styling. */}
                <code className="language-text">
                    {s.name}
                </code>
                <br/>
                <code className="language-text">
                    {s.radius}
                </code>
            </span>
        ))}
    </>
);
